import React from "react";
import * as Yup from 'yup';
import { TipoContrattoSelector } from "../../tipiContratto/components/TipoContrattoSelector";
import { Contratto, TipoContratto } from "../../generated";
import { withTipiContratto } from "../../tipiContratto/withTipiContratto";
import { Dictionary } from "../../common/AbstractStores";
import DatesHelper from "../../common/datesHelper";
import { Forms } from "../../common/components/CmForms";
const { Form, FormDate, ActionBar } = Forms<Contratto>()


interface Props {
    contratto: Contratto | { idImpianto: number };
    onSubmit: (contratto: Contratto) => void;
    onCancel: () => void;
    tipiContratto: Dictionary<TipoContratto>;
}

function isContratto(contratto: Props["contratto"]): contratto is Contratto {
    return (contratto as any).id != null;
}

export default withTipiContratto(class ContrattoForm extends React.Component<Props> {

    private static validationSchema = Yup.object<Partial<Contratto>>({
        tipoContrattoId: Yup
            .string()
            .required('Campo obbligatorio'),
    })
    private onSubmit = (values: Contratto) => {
        const { contratto, onSubmit, tipiContratto } = this.props;
        const months = tipiContratto[values.tipoContrattoId]?.mesiValidita ?? 0;
        if (isContratto(contratto)) {
            onSubmit({
                dataUltimaModifica: new Date(),
                dataInserimento: contratto.dataInserimento,
                inizioValidita: values.inizioValidita,
                fineValidita: DatesHelper.AddMonths(values.inizioValidita, months),
                tipoContrattoId: values.tipoContrattoId,
                id: contratto.id,
                idImpianto: contratto.idImpianto,
            } as Contratto);
        }
        else {
            onSubmit(new Contratto({
                dataUltimaModifica: new Date(),
                dataInserimento: new Date(),
                tipoContrattoId: values.tipoContrattoId,
                inizioValidita: values.inizioValidita,
                fineValidita: DatesHelper.AddMonths(values.inizioValidita, months),
                id: "",
                idImpianto: contratto.idImpianto,
            }));
        }
    };

    render() {
        const { contratto } = this.props;
        return (
            <Form
                onSubmit={this.onSubmit}
                initialValues={isContratto(contratto) ? contratto : new Contratto}
                validationSchema={ContrattoForm.validationSchema}
            >
                {
                    ({ set, values }) =>
                        <>
                            <hr className="mt-0 mb-5" />
                            <div className="row">
                                <div className="col-6">
                                    <TipoContrattoSelector
                                        value={values.tipoContrattoId}
                                        onChange={tipoContratto => set("tipoContrattoId", tipoContratto?.id ?? "")}
                                        label="Tipo Contratto"
                                    />
                                </div>
                                <div className="col-6">
                                    <FormDate
                                        name="inizioValidita"
                                        label="Inizio validità"

                                    />
                                </div>
                            </div>
                            <ActionBar
                                onCancel={this.props.onCancel}
                            />
                        </>
                }
            </Form>
        );
    }
})(x => x.allByKey(), "tipiContratto")
